import { OrganizationSelectProvider } from './OrganizationSelectContext';

const Providers = ({ children }) => (
    <OrganizationSelectProvider>
      {children}
    </OrganizationSelectProvider>
);

export default Providers;
